/// <amd-module name="Artifacts/FeedPicker/redux/Reducer" />
import {
  FeedPickerActions,
  FeedPickerActionTypes,
  ILoadCompletedPayload,
} from "Artifacts/FeedPicker/redux/Actions";
import { IFeedPickerState } from "Artifacts/FeedPicker/redux/Contracts";
import { LoadingComponentState } from "Artifacts/Root/helpers/ComponentStateHelpers";
import { syncComponentState } from "Artifacts/Root/Redux";
import produce from "immer";

const initialState = (): IFeedPickerState => ({
  componentState: LoadingComponentState(),
  feeds: [],
  deletedFeeds: [],
});

export const feedPickerReducer = produce((draft: IFeedPickerState, action: FeedPickerActions) => {
  syncComponentState(draft, "componentState", action, {
    ready: FeedPickerActionTypes.LoadDataCompleted,
    loading: FeedPickerActionTypes.LoadDataStarted,
    error: FeedPickerActionTypes.LoadDataFailed,
  });
  switch (action.type) {
    case FeedPickerActionTypes.LoadDataCompleted:
      draft.feeds = (action.payload as ILoadCompletedPayload).feeds;
      draft.deletedFeeds = (action.payload as ILoadCompletedPayload).deletedFeeds;
      break;
  }
  return draft;
}, initialState());
